module.exports = __webpack_public_path__ + "media/images/soar/comments_clock-225f381d03b49bb98c868c154b2feac0.png";